const animatedElement = document.querySelectorAll('[data-animate]');

const options = {
  threshold: 0.5,
};

const inViewCallback = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      entry.target.classList.add('is-animated');
    }
  });
};

const observer = new IntersectionObserver(inViewCallback, options);

animatedElement.forEach((element) => {
  observer.observe(element);
});
